/**
 * Servicio para gestión de categorías dinámicas de estampados y hojas
 */
import api from "./api";

export interface Categoria {
  id: string;
  tipo: 'estampado' | 'hoja';
  slug: string;
  label: string;
  emoji: string;
  descripcion: string;
  color: string;
  active: boolean;
  createdAt?: string;
}

export interface CategoriasResponse {
  success: boolean;
  categorias: Categoria[];
  count: number;
}

export interface CreateCategoriaResponse {
  success: boolean;
  categoria: Categoria;
  message: string;
}

export const categoriasService = {
  /**
   * Obtener categorías activas (opcionalmente por tipo)
   */
  async getCategorias(tipo?: 'estampado' | 'hoja'): Promise<Categoria[]> {
    const endpoint = tipo ? `/categorias?tipo=${tipo}` : '/categorias';
    const response = await api.get<CategoriasResponse>(endpoint);
    return response.data.categorias;
  },

  /**
   * ADMIN: Obtener todas las categorías incluyendo inactivas
   */
  async getCategoriasAdmin(tipo?: 'estampado' | 'hoja'): Promise<Categoria[]> {
    const endpoint = tipo ? `/categorias/admin?tipo=${tipo}` : '/categorias/admin';
    const response = await api.get<CategoriasResponse>(endpoint);
    return response.data.categorias;
  },

  /**
   * ADMIN: Crear nueva categoría
   */
  async crearCategoria(data: {
    tipo: 'estampado' | 'hoja';
    slug: string;
    label: string;
    emoji?: string;
    descripcion?: string;
    color?: string;
  }): Promise<Categoria> {
    const response = await api.post<CreateCategoriaResponse>('/categorias', data);
    return response.data.categoria;
  },

  /**
   * ADMIN: Actualizar categoría existente
   */
  async actualizarCategoria(id: string, data: Partial<Omit<Categoria, 'id' | 'tipo' | 'slug'>>): Promise<Categoria> {
    const response = await api.put<CreateCategoriaResponse>(`/categorias/${id}`, data);
    return response.data.categoria;
  },

  /**
   * ADMIN: Eliminar categoría (solo si no tiene elementos en uso)
   */
  async eliminarCategoria(id: string): Promise<void> {
    await api.delete(`/categorias/${id}`);
  },
};

export default categoriasService;
